import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// current User Details
export const GetSingleServer = createAsyncThunk(
  "server/getSingleServer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/server/admin/${data.id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during server data.";
      return rejectWithValue(errorMessage);
    }
  }
);

// save a new user
export const saveNewServer = createAsyncThunk(
  "server/saveNewServer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/server/new`,
        data ,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during adding server.";
      return rejectWithValue(errorMessage);
    }
  }
);

// get all the users --admin
export const getAllServer = createAsyncThunk(
  "server/getAllServer",
  async (data, { rejectWithValue }) => {
    try {

      console.log('getting data from getallserver')

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/server/all`,
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
        // {
        //   headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY3NDQ3MjRiZWRjYjU5YjQ2NzMxM2FhYyIsInJlZnJlc2hUb2tlbiI6ImMyYTI1OThhOWE1MDUxMjAiLCJpYXQiOjE3MzI2MjcxMzYsImV4cCI6MTczMjcxMzUzNn0.--cyDg0YrNo75GztH0edknspRD40Cn9fCUVkbqcn4EM` },
        // }
      );

       console.log('getting data of server', response?.data)
      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data?.result;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during login.";
      return rejectWithValue(errorMessage);
    }
  }
);

// update a user  --admin
export const updateService = createAsyncThunk(
  "server/updateServer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/server/admin/${data.id}`,
        data.data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during update server.";
      return rejectWithValue(errorMessage);
    }
  }
);

// block a user  --admin
export const blockServer = createAsyncThunk(
  "server/blockServer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/server/admin/${data.id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during delete server.";
      return rejectWithValue(errorMessage);
    }
  }
);



